import React from "react";

function SidebarMenu({ onSelect, selected }) {
  const menuItems = [
    { name: "Users", icon: "/sysGuardIcons/userIcon.svg" },
    { name: "Locations", icon: "/sysGuardIcons/place.svg" },
    { name: "Applications", icon: "/sysGuardIcons/settingsIcon.svg" },
  ];

  return (
    <div className="sidebar-container">
      {menuItems.map((item) => (
        <div
          key={item.name}
          className={`menu-item ${
            selected === item.name ? `${item.name} active` : `${item.name}`
          }`}
          onClick={() => {
            onSelect(item.name);
          }}
        >
          <img src={item.icon} alt={item.name} />
          <span>{item.name}</span>
        </div>
      ))}
    </div>
  );
}

export default SidebarMenu;
